import { ArrowRight, CalendarCheck } from "lucide-react";
import { HOME_WRAP, SectionEyebrow } from "./HomeShared";
import { results } from "./HomeData";
import { useAppointment } from "../../context/AppointmentContext";

export default function ResultsSection() {
  const { openAppointment } = useAppointment();

  return (
    <section id="before-after" className={`${HOME_WRAP} py-8`}>
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <SectionEyebrow>Real Results - Real People</SectionEyebrow>
          <h2 className="text-[34px] font-bold leading-tight text-[#071746] md:text-[44px]">Smile That Changes Everythings</h2>
          <p className="mt-2 text-[17px] text-[#4d5b7c]">Every transformation starts with a consultation-restoring confidence through exceptional dentistry.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={openAppointment}
            className="inline-flex h-[52px] items-center justify-center gap-2 rounded-[10px] bg-[#0052ff] px-7 text-[16px] font-semibold text-white transition hover:bg-[#003ec2]"
          >
            <CalendarCheck className="h-5 w-5" />
            Start Yours
          </button>
          <a href="/testimonials" className="inline-flex h-[52px] items-center justify-center gap-3 rounded-[10px] border border-[#aeb3bd] px-7 text-[16px] font-semibold text-black">
            View More Transformations <ArrowRight className="h-6 w-6" />
          </a>
        </div>
      </div>
      <div className="mt-8 grid gap-6 lg:grid-cols-3">
        {results.map(([title, before, after]) => (
          <article key={title} className="rounded-[12px] border border-[#c7cbd3] bg-white p-5">
            <h3 className="text-[22px] font-bold text-[#071746]">{title}</h3>
            <div className="mt-5 grid grid-cols-2 gap-2">
              {[
                ["Before", before],
                ["After", after],
              ].map(([label, image]) => (
                <div key={label} className="relative aspect-[1/1] overflow-hidden rounded-[7px]">
                  <img src={image} alt={`${title} ${label}`} className="h-full w-full object-cover object-center" />
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
